import React from 'react';

import styled from 'styled-components';

import ProductBadge from '@/ui/components/ContentHeader/ProductBadge';
import { getManyTagsBySlug } from '@/utils/tags/getTagBySlug';

const BadgesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

interface ProductBadgesProps {
  productSlugs?: string[];
  products?: Product[];
  title?: string;
}

export default function ProductBadges({ productSlugs, products, title }: ProductBadgesProps) {
  // Only show badges if title contains "#" symbol (typically error codes)
  const shouldShowBadges = React.useMemo(() => {
    return title && title.includes('#');
  }, [title]);

  const mappedProducts = React.useMemo(() => {
    if (!shouldShowBadges || !productSlugs || !products || productSlugs.length === 0) {
      return [];
    }

    const tags = getManyTagsBySlug({
      tags: products,
      slugs: productSlugs,
    });

    return tags;
  }, [shouldShowBadges, productSlugs, products]);

  if (!shouldShowBadges || !mappedProducts || mappedProducts.length === 0) {
    return null;
  }

  return (
    <BadgesWrapper>
      {mappedProducts.map(product => (
        <ProductBadge key={product.id} product={product} noLink />
      ))}
    </BadgesWrapper>
  );
}
